import { Button, LinearProgress } from "@mui/material"
import { Apps } from "@mui/icons-material"

type ConnectionsStateVariant = "loading" | "error" | "empty"

const STATE_COPY_BY_VARIANT: Record<ConnectionsStateVariant, { title: string, description: string }> = {
  loading: {
    title: "Gathering your connections...",
    description: "",
  },
  error: {
    title: "Unable to load your connected applications.",
    description: "Please try again.",
  },
  empty: {
    title: "No connected applications",
    description: "You don't have any connected applications yet. Once you connect one, it will appear here.",
  },
}

interface ConnectionsStatePanelProps {
  isLoading: boolean
  isError: boolean
  isEmpty: boolean
  onRetry: () => void
}

export default function ConnectionsStatePanel({
  isLoading,
  isError,
  isEmpty,
  onRetry,
}: ConnectionsStatePanelProps) {
  if (!isLoading && !isError && !isEmpty) return null

  const variant: ConnectionsStateVariant = isLoading ? "loading" : (isError ? "error" : "empty")
  const { title, description } = STATE_COPY_BY_VARIANT[variant]

  return <div className={`connections-empty-state connections-state-panel connections-state-panel--${variant}`}>
    <Apps className="connections-empty-state-icon" />
    <div className="connections-empty-state-title">{title}</div>
    {description && <div className="connections-empty-state-description">{description}</div>}
    {variant === "loading" && <div className="connections-state-panel-progress">
      <LinearProgress />
    </div>}
    {variant === "error" && <Button onClick={onRetry} color="primary" variant="contained">Retry</Button>}
  </div>
}
